module.exports = __webpack_public_path__ + "static/media/DT2.bda5c389.jpg";